import { serviceMaker } from "..";
import { IActiveInactive, IPagination } from "../../data/AppInterface";
import { TBitValue } from "../../data/AppType";
import { IHsnSacCodeAdvancedSearch } from "../../screens/hsn-sac-code/HSNCodeViewController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

export interface IHsnSacCodePayload {
  id?: string;
  hsn_sac_code: string;
  chapter: string;
  description: string;
  rate_percentage?: number[];
  effective_from?: string;
  end_date?: Date;
  is_active: TBitValue;
}

export const GET_ALL_HSN_SAC_CODE = (
  pagination: IPagination,
  search: string,
  advanceSearch: IHsnSacCodeAdvancedSearch
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_hsn_sac_code.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }&sd=${advanceSearch.sd}`,
    API_ENDPOINTS.get_all_hsn_sac_code.method
  );
export const GET_HSN_SAC_CODE_BY_ID = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.get_all_hsn_sac_code.url + `/${id}`,
    API_ENDPOINTS.get_all_hsn_sac_code.method
  );
};
export const CREATE_HSN_SAC_CODE = (payload: IHsnSacCodePayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_hsn_sac_code.url,
    API_ENDPOINTS.create_hsn_sac_code.method,
    payload
  );
};

export const UPDATE_HSN_SAC_CODE = (
  payload: IHsnSacCodePayload,
  id: string
) => {
  return serviceMaker(
    API_ENDPOINTS.update_hsn_sac_code.url + `/${id}`,
    API_ENDPOINTS.update_hsn_sac_code.method,
    payload
  );
};

export const ACTIVE_INACTIVE_HSN_SAC_CODE = async (
  id: string,
  activeInactiveValue: IActiveInactive
) => {
  return serviceMaker(
    API_ENDPOINTS.active_inactive_hsn_sac_code.url + `/${id}`,
    API_ENDPOINTS.active_inactive_hsn_sac_code.method,
    activeInactiveValue
  );
};

export const DELETE_HSN_SAC_CODE = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_hsn_sac_code.url + `/${id}`,
    API_ENDPOINTS.delete_hsn_sac_code.method
  );
};
